var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 377.26,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 134.74
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 134.74
  }), /*#__PURE__*/React.createElement("rect", {
    y: 134.74,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 242.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M332.405,212.395l20.278,26.527l31.663-10.598c1.77-0.593,3.276,1.409,2.216,2.946L367.6,258.752   l19.864,26.838c1.111,1.501-0.328,3.552-2.117,3.018l-31.997-9.542l-19.386,27.185c-1.084,1.52-3.479,0.786-3.525-1.081   l-0.813-33.379l-31.845-10.037c-1.781-0.561-1.822-3.066-0.061-3.686l31.495-11.088l-0.295-33.388   C328.902,211.726,331.271,210.912,332.405,212.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M277.369,321.475c-36.132,0-65.442-29.31-65.442-65.475c0-36.098,29.31-65.474,65.442-65.474   c13.443,0,25.84,4.135,36.171,11.132c1.582,1.072,3.388-1.007,2.063-2.385c-15.44-16.053-37.294-25.846-61.523-25.02   c-41.628,1.421-76.089,34.796-78.749,76.363c-3.047,47.612,34.653,87.179,81.591,87.179c23.121,0,43.9-9.666,58.74-25.121   c1.311-1.365-0.499-3.413-2.066-2.351C303.253,317.335,290.836,321.475,277.369,321.475z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLy);
export default __webpack_public_path__ + "static/media/ly.a2f750ababdc4b3dd0603d3b106018c8.svg";
export { ForwardRef as ReactComponent };